<template>

<div class="connectedgroups">

	<h3 class="connectedgroups-title">{{ item.content }}</h3>

	<app-content-group v-for="(group, index) in groups" :key="index" :item="group" />

</div>

</template>

<script>

export default {

	props: ['item'],

	computed: {

		groups: function() {

			var matchedGroups = []
			var texts = []
			var groups = []

			if (this.$route.params.location) {

				var location = this.$_.findWhere(this.$store.getters['locations'], {
					slug: this.$route.params.location
				})

				texts = this.$_.pluck(this.$_.filter(this.$store.getters['texts'], function(text) {

					return location.id === text.location

				}.bind(this)), 'id')

				matchedGroups = this.$_.pluck(this.$_.filter(this.$store.getters['groups'], function(group) {

					return this.$_.intersection(group.texts, texts).length && group.visible && group.category

				}.bind(this)), 'id')

				matchedGroups = matchedGroups.concat(this.$_.pluck(this.$_.filter(this.$store.getters['groups'], function(group) {

					var matched = false

					if (group.format) {

						this.$_.each(group.content, function(section) {

							if (section.enabled) {

								this.$_.each(section.blocks, function(block) {

									if (block.enabled && block.location && !matched) {

										matched = block.location === location.id

									}

								}.bind(this))

							}

						}.bind(this))

					}

					return matched

				}.bind(this)), 'id'))

			} else {

				//
				
			}

			this.$_.each(matchedGroups, function(id) {

				groups.push({
					group: id,
					name: this.$store.getters['groups/findbyid'](id).title
				})

			}.bind(this))

			groups = this.$_.sortBy(groups, 'name')

			return groups

		}

	}

}

</script>

<style scoped>

.connectedgroups-title {
	color: #595959;
	font-size: 16px;
	text-transform: uppercase;
	letter-spacing: 1.4px;
	margin-top: 30px;
	margin-bottom: 10px;
	font-weight: 300;
	font-family: Roboto Slab,serif;
}

</style>
